import { combineReducers } from "redux";
import CandidateReducer from "../redux/reducer/CandidateReducer";
import ClientPartnerReducer from "../redux/reducer/ClientPartnerReducer";
import CoverSheetReducer from "../redux/reducer/CoverSheetReducer";
import HarizonReducer from "../redux/reducer/HarizonReducer";
import JobReducer from "../redux/reducer/JobReducer";
import QuickMatchReducer from "../redux/reducer/QuickMatchReducer";
import ResumeIntelligenceReducer from "../redux/reducer/ResumeIntelligence";
import LayoutReducer from "../redux/reducer/LayoutReducer";
import IgniteReducer from "../redux/reducer/IgniteReducer";
import SubmissionReducer from "../redux/reducer/SubmissionReducer";
import FeedbackReducer from "../redux/reducer/FeedbackReducer";
import ShowSnackbarReducer from "../redux/reducer/ShowSnackbarReducer";
import NotificationReducer from "../redux/reducer/NotificationReducer";

const appReducer = combineReducers({
  quickMatchState: QuickMatchReducer,
  jobs: JobReducer,
  resumeIntelligence: ResumeIntelligenceReducer,
  candidate: CandidateReducer,
  coverSheet: CoverSheetReducer,
  harizon: HarizonReducer,
  client_partner: ClientPartnerReducer,
  layout: LayoutReducer,
  sow: IgniteReducer,
  submission: SubmissionReducer,
  feedback: FeedbackReducer,
  snackbar: ShowSnackbarReducer,
  notification: NotificationReducer,
});

const reducer = (state, action) => {
  if (action.type === "RESET_ALL") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default reducer;
